import styled from 'styled-components';
import { media } from '../../../../helpers/breakpoints';

export interface SectionBreakHeaderProps {
  title?: string;
}

const Title = styled.h2`
  ${({ theme }) => theme.fontSize.L18}

  ${media.large} {
    ${({ theme }) => theme.fontSize.L24}
  }
`;

export const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  margin-top: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    margin-bottom: ${({ theme }) => theme.spacing.M24};
    margin-top: ${({ theme }) => theme.spacing.L40};
  }
`;

function SectionBreakHeader({ title }: SectionBreakHeaderProps) {
  return <Container>{title && <Title>{title}</Title>}</Container>;
}

export { SectionBreakHeader };
